// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SweetAlert2 - LabelFlow polish layer.
 * Base popup surface (bg / border / radius / shadow / typography) is themed
 * globally in src/styles/theme-overrides.css. This file only adds layout
 * and button styling, expressed through design tokens so it works in
 * both light and dark themes.
 */

/* === Backdrop === */
.swal2-container {
  z-index: 2000 !important;
}

.swal2-container.swal2-backdrop-show {
  background: var(--overlay) !important;
  backdrop-filter: blur(4px);
}

/* === Popup layout (surface colors come from theme-overrides.css) === */
.swal2-popup {
  padding: 2rem 2rem 1.75rem !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 1.25rem !important;
  max-width: 420px !important;
}

/* === Custom icon image === */
.swal2-popup .swal2-image {
  margin: 0 !important;
  width: 56px !important;
  height: 56px !important;
}

/* === Title === */
.swal2-popup .swal2-title {
  padding: 0 !important;
  margin: 0 !important;
  font-size: 1.25rem !important;
  font-weight: 600 !important;
  line-height: 1.4 !important;
}

/* === Message body === */
.swal2-popup .swal2-html-container {
  padding: 0 !important;
  margin: 0 !important;
  font-size: 0.9375rem !important;
  line-height: 1.6 !important;
}

.swal2-popup .swal2-html-container span {
  color: var(--primary) !important;
  font-weight: 500 !important;
}

.swal2-popup .swal2-html-container p {
  margin: 0.5rem 0 !important;
  color: var(--foreground) !important;
}

/* === Actions / Buttons === */
.swal2-popup .swal2-actions {
  margin: 0.25rem 0 0 !important;
  gap: 0.75rem !important;
}

/* Confirm button - primary */
.swal2-popup .swal2-confirm {
  background: var(--primary) !important;
  border: none !important;
  border-radius: var(--radius-sm) !important;
  color: var(--primary-foreground) !important;
  font-weight: 600 !important;
  font-size: 0.9375rem !important;
  padding: 0.5rem 1.25rem !important;
  box-shadow: var(--shadow-sm) !important;
  transition: all var(--transition-fast) !important;
}

.swal2-popup .swal2-confirm:hover {
  background: var(--primary-hover) !important;
  transform: translateY(-1px) !important;
  box-shadow: var(--shadow-glow) !important;
}

.swal2-popup .swal2-confirm:active {
  transform: translateY(0) !important;
}

/* Cancel button - secondary/muted */
.swal2-popup .swal2-cancel {
  background: var(--secondary) !important;
  border: 1px solid var(--border) !important;
  border-radius: var(--radius-sm) !important;
  color: var(--secondary-foreground) !important;
  font-weight: 500 !important;
  font-size: 0.9375rem !important;
  padding: 0.5rem 1.25rem !important;
  transition: all var(--transition-fast) !important;
}

.swal2-popup .swal2-cancel:hover {
  background: var(--secondary-hover) !important;
  border-color: var(--border-strong) !important;
  color: var(--foreground) !important;
}

/* Deny button - destructive style */
.swal2-popup .swal2-deny {
  background: var(--destructive) !important;
  border: none !important;
  border-radius: var(--radius-sm) !important;
  color: var(--destructive-foreground) !important;
  font-weight: 600 !important;
}

.swal2-popup .swal2-deny:hover {
  background: var(--destructive-hover) !important;
}

/* === Loader === */
.swal2-popup .swal2-actions .swal2-loader {
  border-color: var(--primary) transparent var(--primary) transparent !important;
}

.swal2-popup.swal2-loading {
  position: relative !important;
  padding-top: 6rem !important;
}

.swal2-popup.swal2-loading .swal2-loader {
  margin: 0 !important;
  position: absolute !important;
  top: 2rem !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
}

/* === Success icon (when using built-in icon) === */
.swal2-icon.swal2-success {
  border-color: var(--success) !important;
}

.swal2-icon.swal2-success [class^='swal2-success-line'] {
  background-color: var(--success) !important;
}

.swal2-icon.swal2-success .swal2-success-ring {
  border-color: var(--ring) !important;
}

/* === Error icon === */
.swal2-icon.swal2-error {
  border-color: var(--destructive) !important;
}

.swal2-icon.swal2-error [class^='swal2-x-mark-line'] {
  background-color: var(--destructive) !important;
}

/* === Warning icon === */
.swal2-icon.swal2-warning {
  border-color: var(--warning) !important;
  color: var(--warning) !important;
}

.swal2-icon.swal2-warning [class^='swal2-warning'] {
  color: var(--warning) !important;
}

/* === Input fields (if used) === */
.swal2-popup .swal2-input,
.swal2-popup .swal2-textarea {
  border: 1px solid var(--input) !important;
  border-radius: var(--radius-sm) !important;
  color: var(--foreground) !important;
}

.swal2-popup .swal2-input:focus,
.swal2-popup .swal2-textarea:focus {
  border-color: var(--primary) !important;
  box-shadow: 0 0 0 3px var(--ring) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Notifications/swal/sweetalert.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF,qBAAqB;AACrB;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA,wEAAwE;AACxE;EACE,qCAAqC;EACrC,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,oBAAoB;EACpB,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,oBAAoB;EACpB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,qCAAqC;EACrC,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;EAC3C,2BAA2B;EAC3B,+BAA+B;EAC/B,kCAAkC;EAClC,uCAAuC;EACvC,iDAAiD;AACnD;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;AACrC;;AAEA,oCAAoC;AACpC;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,0CAA0C;EAC1C,6CAA6C;EAC7C,2BAA2B;EAC3B,+BAA+B;EAC/B,kCAAkC;EAClC,iDAAiD;AACnD;;AAEA;EACE,6CAA6C;EAC7C,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA,oCAAoC;AACpC;EACE,yCAAyC;EACzC,uBAAuB;EACvB,0CAA0C;EAC1C,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;AACjD;;AAEA,mBAAmB;AACnB;EACE,8EAA8E;AAChF;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA,oDAAoD;AACpD;EACE,uCAAuC;AACzC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,2CAA2C;AAC7C;;AAEA;EACE,+CAA+C;AACjD;;AAEA,yBAAyB;AACzB;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,mCAAmC;AACnC;;EAEE,yCAAyC;EACzC,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;;EAEE,uCAAuC;EACvC,4CAA4C;AAC9C","sourcesContent":["/**\n * SweetAlert2 - LabelFlow polish layer.\n * Base popup surface (bg / border / radius / shadow / typography) is themed\n * globally in src/styles/theme-overrides.css. This file only adds layout\n * and button styling, expressed through design tokens so it works in\n * both light and dark themes.\n */\n\n/* === Backdrop === */\n.swal2-container {\n  z-index: 2000 !important;\n}\n\n.swal2-container.swal2-backdrop-show {\n  background: var(--overlay) !important;\n  backdrop-filter: blur(4px);\n}\n\n/* === Popup layout (surface colors come from theme-overrides.css) === */\n.swal2-popup {\n  padding: 2rem 2rem 1.75rem !important;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  gap: 1.25rem !important;\n  max-width: 420px !important;\n}\n\n/* === Custom icon image === */\n.swal2-popup .swal2-image {\n  margin: 0 !important;\n  width: 56px !important;\n  height: 56px !important;\n}\n\n/* === Title === */\n.swal2-popup .swal2-title {\n  padding: 0 !important;\n  margin: 0 !important;\n  font-size: 1.25rem !important;\n  font-weight: 600 !important;\n  line-height: 1.4 !important;\n}\n\n/* === Message body === */\n.swal2-popup .swal2-html-container {\n  padding: 0 !important;\n  margin: 0 !important;\n  font-size: 0.9375rem !important;\n  line-height: 1.6 !important;\n}\n\n.swal2-popup .swal2-html-container span {\n  color: var(--primary) !important;\n  font-weight: 500 !important;\n}\n\n.swal2-popup .swal2-html-container p {\n  margin: 0.5rem 0 !important;\n  color: var(--foreground) !important;\n}\n\n/* === Actions / Buttons === */\n.swal2-popup .swal2-actions {\n  margin: 0.25rem 0 0 !important;\n  gap: 0.75rem !important;\n}\n\n/* Confirm button - primary */\n.swal2-popup .swal2-confirm {\n  background: var(--primary) !important;\n  border: none !important;\n  border-radius: var(--radius-sm) !important;\n  color: var(--primary-foreground) !important;\n  font-weight: 600 !important;\n  font-size: 0.9375rem !important;\n  padding: 0.5rem 1.25rem !important;\n  box-shadow: var(--shadow-sm) !important;\n  transition: all var(--transition-fast) !important;\n}\n\n.swal2-popup .swal2-confirm:hover {\n  background: var(--primary-hover) !important;\n  transform: translateY(-1px) !important;\n  box-shadow: var(--shadow-glow) !important;\n}\n\n.swal2-popup .swal2-confirm:active {\n  transform: translateY(0) !important;\n}\n\n/* Cancel button - secondary/muted */\n.swal2-popup .swal2-cancel {\n  background: var(--secondary) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: var(--radius-sm) !important;\n  color: var(--secondary-foreground) !important;\n  font-weight: 500 !important;\n  font-size: 0.9375rem !important;\n  padding: 0.5rem 1.25rem !important;\n  transition: all var(--transition-fast) !important;\n}\n\n.swal2-popup .swal2-cancel:hover {\n  background: var(--secondary-hover) !important;\n  border-color: var(--border-strong) !important;\n  color: var(--foreground) !important;\n}\n\n/* Deny button - destructive style */\n.swal2-popup .swal2-deny {\n  background: var(--destructive) !important;\n  border: none !important;\n  border-radius: var(--radius-sm) !important;\n  color: var(--destructive-foreground) !important;\n  font-weight: 600 !important;\n}\n\n.swal2-popup .swal2-deny:hover {\n  background: var(--destructive-hover) !important;\n}\n\n/* === Loader === */\n.swal2-popup .swal2-actions .swal2-loader {\n  border-color: var(--primary) transparent var(--primary) transparent !important;\n}\n\n.swal2-popup.swal2-loading {\n  position: relative !important;\n  padding-top: 6rem !important;\n}\n\n.swal2-popup.swal2-loading .swal2-loader {\n  margin: 0 !important;\n  position: absolute !important;\n  top: 2rem !important;\n  left: 50% !important;\n  transform: translateX(-50%) !important;\n}\n\n/* === Success icon (when using built-in icon) === */\n.swal2-icon.swal2-success {\n  border-color: var(--success) !important;\n}\n\n.swal2-icon.swal2-success [class^='swal2-success-line'] {\n  background-color: var(--success) !important;\n}\n\n.swal2-icon.swal2-success .swal2-success-ring {\n  border-color: var(--ring) !important;\n}\n\n/* === Error icon === */\n.swal2-icon.swal2-error {\n  border-color: var(--destructive) !important;\n}\n\n.swal2-icon.swal2-error [class^='swal2-x-mark-line'] {\n  background-color: var(--destructive) !important;\n}\n\n/* === Warning icon === */\n.swal2-icon.swal2-warning {\n  border-color: var(--warning) !important;\n  color: var(--warning) !important;\n}\n\n.swal2-icon.swal2-warning [class^='swal2-warning'] {\n  color: var(--warning) !important;\n}\n\n/* === Input fields (if used) === */\n.swal2-popup .swal2-input,\n.swal2-popup .swal2-textarea {\n  border: 1px solid var(--input) !important;\n  border-radius: var(--radius-sm) !important;\n  color: var(--foreground) !important;\n}\n\n.swal2-popup .swal2-input:focus,\n.swal2-popup .swal2-textarea:focus {\n  border-color: var(--primary) !important;\n  box-shadow: 0 0 0 3px var(--ring) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
